import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProfileService } from '../profile.service';

export const loginGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  if (profileService.isAuthenticated()) {
    void router.navigate(['/']);
    return false;
  }

  return true;
};
